import {Component, computed, effect, inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {WizardService} from './wizard.service';

@Component({
  template: '',
})
export abstract class BaseStepComponent<T = never, F = any> implements OnInit, OnDestroy {
  abstract form: F;
  abstract stepIndex: number;
  protected destroy$ = new Subject<void>();
  protected formData: Partial<T> | undefined;
  protected wizardService = inject(WizardService<T>);

  protected abstract readonly isValidComputed: ReturnType<typeof computed<boolean>>;

  constructor() {
    effect(() => {
      const isValid = this.isValidComputed();
      this.wizardService.updateStepValidity({
        stepIndex: this.stepIndex,
        isValid,
      });
    });
  }

  ngOnInit(): void {
    this.formData = this.wizardService.formData;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
